export const socialSelector = {
  socialSelectorViewStories: "查看故事",
  socialSelectorGoToProfile: "前往档案",
  socialSelectorGoToCommunity: "前往社区",
  socialSelectorCancel: "取消",
  socialSelectorOptionsFor: "{{name}} 的选项",
  socialSelectorLabelAyg: "官方平台",
  socialSelectorLabelProvider: "游戏供应商",
  socialSelectorLabelUser: "玩家",
  socialSelectorLabelCommunity: "AYG 社区",
  socialSelectorPlayInFeed: "在动态中玩",
};
